import React from 'react';
import { Button } from 'antd';

const BackButton = ({ onPrevious, ...rest }) => {
	return (
		<Button
			{...rest}
			onClick={onPrevious}
		>Back </Button>
	);
};

export default BackButton;